import { ListScreen, StackScreenProps } from '@rahtab/stack-navigator';
import { fixDateTime, withSeparator } from '@rahtab/system/lib/tools/string';
import { Colors, getSpacing, ItemCard, ListEmpty, Picker, Rating, Tag, Text, TextView } from '@rahtab/ui';
import MerchandiseListEmptyIcon from '@rahtab/ui/dist/icons/ListEmptyIcons/StoreMerchandises';
import SortIcon from '@rahtab/ui/dist/icons/SortIcon';
import { RootStackType } from 'components/Router';
import { useLoadsList } from 'hooks/InventoryHooks/useLoadsList';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import LoadItem from './LoadItem';

const defaultMerchandise = require('assets/images/defaultMerchandise.png');

const LoadsList: React.VFC<LoadsListProps> = ({ route }) => {
  const { merchandiseId, providerCode } = route.params;
  const { refreshControl, screenProps, fetchMoreIds } = useLoadsList({ id: merchandiseId, providerCode });
  return (
    <ListScreen
      {...screenProps}
      {...refreshControl}
      title="بارهای دریافتی از کالا"
      renderControls={(info) => {
        return (
          <View>
            <ItemCard
              title={info.name}
              image={info.imageUrl}
              hasChevron={false}
              inHeader
              defaultImage={defaultMerchandise}
              statusBadge={
                <Tag text="کد: ">
                  <Text color="primary" variant="subtitle" margin="none">
                    {merchandiseId}
                  </Text>
                </Tag>
              }>
              <Text color="description">
                مجموع موجودی بارها:
                <Text>
                  {' '}
                  {withSeparator(info.totalRemainingValue)} {info.measureName}
                </Text>
              </Text>
              <Rating count={info.commentCount} value={0} />
            </ItemCard>
            <View style={styles.controlRowContainer}>
              <TextView
                title="تعداد بارها"
                value={info.assignFinallCount}
                isSpaceBetween
                style={styles.amountTextView}
              />
              <Picker
                placeholder="مرتب‌سازی بر اساس"
                selectedValue="newest"
                customIcon={<SortIcon fill={Colors.primary} />}
                style={styles.sortPicker}
                variant="outlined"
                color="primary">
                <Picker.Item label="جدیدترین" value="newest" />
              </Picker>
            </View>
          </View>
        );
      }}
      keyExtractor={(_, index) => `loads-${index}`}
      onEndReached={() => {
        if (screenProps.listData.length < screenProps.data?.assignFinallCount)
          fetchMoreIds({
            params: `TemplateCode=${merchandiseId}&RowID=${screenProps.listData.length}&Count=10&ProviderCode=${providerCode}`,
          });
      }}
      onEndReachedThreshold={0.3}
      ListEmptyComponent={
        !refreshControl.refreshing ? (
          <ListEmpty text="باری یافت نشد." imageComponent={<MerchandiseListEmptyIcon />} />
        ) : null
      }
      renderItem={({ item }) => {
        if (item) {
          return (
            <LoadItem
              availableLoad={
                item.remainingValue !== 0 ? `${withSeparator(item.remainingValue)} ${item.measureName}` : 'ناموجود'
              }
              receivedDate={fixDateTime(item.receiveDate)}
              deliveredDate={fixDateTime(item.deliveryDate)}
              assignedDate={fixDateTime(item.assignDate)}
              distributer={item.middlemanName}
              name={item.loadName}
              screenName="ReceivedLoad"
              params={{
                assignFinalCode: item.assignFinallCode,
                merchandiseId,
              }}
              statusCode={item.statusCode}
              status={item.status}
            />
          );
        }
        return null;
      }}
    />
  );
};

export default LoadsList;

const styles = StyleSheet.create({
  controlRowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: getSpacing(),
  },
  amountTextView: {
    flex: 1,
    marginRight: getSpacing(),
    marginBottom: 0,
  },
  sortPicker: {
    flex: 2,
    marginBottom: 0,
    // backgroundColor:Colors.card,
  },
});

interface LoadsListProps extends StackScreenProps<RootStackType, 'LoadsList'> {}
